import api from './api';
import {
  DemandForecast,
  CreateDemandForecastRequest,
  UpdateDemandForecastRequest,
  DemandForecastQueryParams,
  PaginatedDemandForecasts,
  DemandForecastSummary,
  CalculateForecastRequest,
  CalculatedForecast,
  GenerateForecastsRequest,
} from '../types/demand-forecasting.types';

const BASE_URL = '/demand-forecasting';

export const demandForecastingService = {
  async getPage(query: DemandForecastQueryParams): Promise<PaginatedDemandForecasts> {
    const params = {
      page: query.page,
      limit: query.limit,
      ...(query.search ? { search: query.search } : {}),
      ...(query.method ? { method: query.method } : {}),
      ...(query.period ? { period: query.period } : {}),
      ...(query.isActive !== undefined ? { isActive: query.isActive } : {}),
      ...(query.actuals ? { actuals: query.actuals } : {}),
      ...(query.dateFrom ? { dateFrom: query.dateFrom } : {}),
      ...(query.dateTo ? { dateTo: query.dateTo } : {}),
    };
    const response = await api.get<PaginatedDemandForecasts>(`${BASE_URL}/paginated`, { params });
    return response.data;
  },

  async getSummary(): Promise<DemandForecastSummary> {
    const response = await api.get<DemandForecastSummary>(`${BASE_URL}/summary`);
    return response.data;
  },

  async getForecastById(id: string): Promise<DemandForecast> {
    const response = await api.get<DemandForecast>(`${BASE_URL}/${id}`);
    return response.data;
  },

  async createForecast(forecast: CreateDemandForecastRequest): Promise<DemandForecast> {
    const response = await api.post<DemandForecast>(BASE_URL, forecast);
    return response.data;
  },

  async updateForecast(id: string, forecast: UpdateDemandForecastRequest): Promise<DemandForecast> {
    const response = await api.patch<DemandForecast>(`${BASE_URL}/${id}`, forecast);
    return response.data;
  },

  async deleteForecast(id: string): Promise<void> {
    await api.delete(`${BASE_URL}/${id}`);
  },

  async updateActualDemand(id: string, actualDemand: number): Promise<DemandForecast> {
    const response = await api.patch<DemandForecast>(`${BASE_URL}/${id}/actual-demand`, { actualDemand });
    return response.data;
  },

  // Works out forecasts from history without saving anything
  async calculateForecasts(request: CalculateForecastRequest): Promise<CalculatedForecast[]> {
    const response = await api.post<{ forecasts: CalculatedForecast[] }>(`${BASE_URL}/calculate`, request);
    return response.data.forecasts;
  },

  // Creates one forecast per future period from the same history
  async generateForecasts(request: GenerateForecastsRequest): Promise<DemandForecast[]> {
    const response = await api.post<DemandForecast[]>(`${BASE_URL}/generate`, request);
    return response.data;
  },
};
